import { CaseJournalNumberFormat, getJournalNumber as computeJournalNumber, } from '../cases/index.js';
const characters = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
];
export const genHash = (prefix, length = 8) => {
    let jnr = '';
    for (let i = 0; i < length; i++) {
        jnr += characters[Math.round(Math.random() * (characters.length - 1))];
    }
    return `${prefix ? `${prefix}-` : ''}${jnr}`;
};
export const genNumber = (prefix, length = 6) => {
    let jnr = '';
    for (let i = 0; i < length; i++) {
        jnr += characters[Math.round(Math.random() * (characters.length - 1))];
    }
    return `${prefix ? `${prefix}-` : ''}${jnr}`;
};
export const parse = (jno) => {
    const jnoElms = jno.split('-');
    jno = jnoElms[jnoElms.length - 1];
    return jno;
};
export const getJournalNumberToShowOnDebtorweb = (tenant, singleCase, user) => {
    if (singleCase.customJournalNumber?.type ===
        CaseJournalNumberFormat.CustomString) {
        return singleCase.customJournalNumber.journalNumber;
    }
    return tenant?.settings.debtorweb?.preferMigratedJrNr && singleCase.migratedId
        ? singleCase.migratedId
        : computeJournalNumber(null, singleCase.id, user?.id ?? null);
};
//# sourceMappingURL=index.js.map